import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import FundsView from '@/themes/themeOne/funds/fundsView.vue';
import { ref,computed} from 'vue'
import { FundViewData } from './fundsView';

export default /*@__PURE__*/_defineComponent({
  __name: 'fundsView',
  setup(__props) {

const availableBalance = ref(0);
const dataSet = computed<FundViewData>(() => ({
    availableBalance: availableBalance.value
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FundsView, { "data-set": dataSet.value }, null, 8, ["data-set"])
  ]))
}
}

})